import { render, staticRenderFns } from "./SegmentSelector.vue?vue&type=template&id=1299a1ee"
import script from "./SegmentSelector.vue?vue&type=script&lang=ts"
export * from "./SegmentSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports